import { ColourOption } from "@/components/Colours/types.ts";
import { Select } from "@JohnLewisPartnership/jl-design-system/dist/components/select/Select";
import React, { ChangeEventHandler } from "react";
import { useRouter } from "next/router";
import {
  DROPDOWN_INTERACTION,
  DROPDOWN_SELECT_COLOUR,
  DROPDOWN_SELECT_PROMO_COLOUR,
} from "@/components/Colours/ColourList/monetateEvents.ts";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

type Props = {
  colourOptions: ColourOption[];
  selectedColourOption: ColourOption;
  replaceHistoryEntryOnVariantChange: boolean;
};

export const Picker = ({
  colourOptions,
  selectedColourOption,
  replaceHistoryEntryOnVariantChange,
}: Props) => {
  const router = useRouter();

  const handleColourChange: ChangeEventHandler<HTMLSelectElement> = (e) => {
    const selectedColourOption = colourOptions.find(
      (colour) => colour.colour === e.target.value,
    );

    if (!selectedColourOption) {
      return;
    }

    dispatchMonetateQEvent(DROPDOWN_SELECT_COLOUR);

    if (selectedColourOption.showReduced) {
      dispatchMonetateQEvent(DROPDOWN_SELECT_PROMO_COLOUR);
    }

    const changeColourFunction = replaceHistoryEntryOnVariantChange
      ? router.replace
      : router.push;

    changeColourFunction(selectedColourOption.url, undefined, {
      shallow: true,
      scroll: false,
    });
  };
  const availableOptions = colourOptions.map((colourOption) => {
    let additionalInformation = "";

    if (!colourOption.showAsAvailable) {
      additionalInformation = " - Out of stock";
    } else if (colourOption.showReduced) {
      additionalInformation = ` - ${colourOption.reducedLabel}`;
    }

    return {
      label: `${colourOption.colour}${additionalInformation}`,
      value: colourOption.colour,
    };
  });

  return (
    <div onClick={() => dispatchMonetateQEvent(DROPDOWN_INTERACTION)}>
      <Select
        id="select-colour"
        name="select-colour"
        data-testid="select-colour"
        aria-label="Select the colour"
        onChange={handleColourChange}
        value={selectedColourOption.colour}
        labelText="Select the colour"
        showLabel={false}
      >
        {availableOptions.map((option) => (
          <option value={option.value} key={option.label}>
            {option.label}
          </option>
        ))}
      </Select>
    </div>
  );
};
